import { useLogoUrl } from './useLogo';

const initialsOf = (name: string): string => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
    return (words[0]![0]! + words[words.length - 1]![0]!).toUpperCase();
};

/**
 * The company's own mark, secondary to the Timely Payment mark beside it.
 *
 * A logo is optional; a company name is not (0010's own reasoning) — so a
 * company with none shows its initials, deliberately, rather than a blank
 * square that reads as broken chrome. Upload or delete never leaves this
 * without something to show: the fallback needs nothing that a failed
 * request could take away.
 */
export function CompanyMark({ name, logoPath }: { name: string; logoPath: string | null }) {
    const url = useLogoUrl(logoPath);

    if (logoPath && url) {
        return (
            <img
                src={url} alt={`${name} logo`}
                className="w-6 h-6 rounded-[6px] object-cover flex-none bg-card-3"
            />
        );
    }

    return (
        <span
            className="w-6 h-6 rounded-[6px] bg-card-3 text-label-2 grid place-items-center font-bold text-[10px] flex-none"
            aria-hidden="true"
        >
            {initialsOf(name)}
        </span>
    );
}
